import React, { useEffect, useState } from 'react'
import './Admin.css'
import Sidebar from '../Sidebar/Sidebar'
import MainDash from '../Main/MainDash'
import { useDispatch, useSelector } from 'react-redux'
import { getAllData } from '../../../redux/operation/dataApi'

const Admin = () => {
    // const dispatch = useDispatch
    const { token } = useSelector(state => state.auth)
    const { data } = useSelector(state => state.data)
    const [item, setItem] = useState([])
    // console.log(data)
    // console.log("toekn un admin s ", token)
    useEffect(() => {
        const fetchDetail = async () => {
            const result = await getAllData(token)
            if (result) {
                setItem(result)
            }
        }
        fetchDetail()
    }, [])
    console.log("item", item)
    return (
        <div className="App">
            <div className="AppGlass">
                <Sidebar />
                <MainDash item={item} />
                {/* <RightSide /> */}
            </div>
        </div>
    )
}

export default Admin